module.exports = __webpack_public_path__ + "static/GT-Haptik-Bold-Rotalic-a775af8413987a02f11f772236f2c3e4.woff2";